<template>
  <el-dialog
    :title="$t('common.map')"
    :visible.sync="viewMapInfo.showMap"
    width="80%"
    :before-close="closeMap"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
  >
    <div class="map-container">
      <div id="tianditu-map-viewer" class="map-viewer"></div>
    </div>
  </el-dialog>
</template>

<script>
import {
  addTiandituMarker,
  clearTiandituMap,
  loadTiandituMapScript,
} from '@/utils/tiandituMap'

export default {
  name: 'ViewMap',
  data() {
    return {
      viewMapInfo: {
        lat: '',
        lng: '',
        showMap: false,
        map: null
      }
    }
  },
  methods: {
    open(param) {
      this.viewMapInfo.showMap = true

      if (param.lng && param.lat) {
        this.viewMapInfo.lat = Number(param.lat)
        this.viewMapInfo.lng = Number(param.lng)
      } else {
        this.viewMapInfo.lat = 36.72
        this.viewMapInfo.lng = 100.985
      }

      this.$nextTick(() => this.initMap())
    },
    async initMap() {
      try {
        await loadTiandituMapScript()
        clearTiandituMap(this.viewMapInfo.map)
        this.viewMapInfo.map = new window.T.Map('tianditu-map-viewer', {
          projection: 'EPSG:4326',
        })
        const point = {
          lng: this.viewMapInfo.lng,
          lat: this.viewMapInfo.lat,
        }
        const result = addTiandituMarker(this.viewMapInfo.map, point, {
          title: this.$t('common.map'),
          iconUrl: '/img/maper.png',
        })
        if (result) {
          this.viewMapInfo.map.centerAndZoom(result.lngLat, 17)
        }
      } catch (error) {
        console.error('天地图加载失败:', error)
        this.$message.error(this.$t('tiandituMap.loadFailed'))
      }
    },
    closeMap() {
      this.viewMapInfo.showMap = false
      clearTiandituMap(this.viewMapInfo.map)
      this.viewMapInfo.map = null
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 500px;
}

.map-viewer {
  width: 100%;
  height: 500px;
}
</style>
